import styled from 'styled-components'

import { breakpoints } from '@src/constants/breakpoints'

export const Container = styled.div`
  display: flex;
  align-items: stretch;
  margin: 0;
`

export const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (min-width: ${breakpoints.tablet}px) {
    margin: 24px 0 0 0;
  }
`

export const SubHeader = styled.h2`
  margin: 12px 0px;
  font-size: 17px;
  font-weight: 700;
  @media (min-width: ${breakpoints.tablet}px) {
    font-size: 24px;
    margin: 0 0 6px 0;
    margin: 0px 24px 6px 4px;
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  font-size: 24px;
  font-weight: 700;
  align-items: flex-start;
  width: auto;
  justify-content: space-between;
  margin: 12px 16px 0 16px;

  @media (min-width: ${breakpoints.tablet}px) {
    margin: 16px 32px 16px 32px;
  }
`

export const SubheaderAndBackButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const MainContainer = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: flex-start;
  gap: 32px;
  width: 100%;
  box-sizing: border-box;
  padding-left: 16px;

  @media (max-width: ${breakpoints.tablet - 1}px) {
    padding-left: 0px;
  }
`

export const NonIdealCategories = styled.div`
  font-size: 16px;
  margin: 8px 16px;

  @media (min-width: ${breakpoints.tablet}px) {
    margin: 24px;
  }
`
